<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">{{title?title:'眼直视激光束的职业接触限值'}}</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="eyeLaserData" style="width: 100%">
      <el-table-column align="center" label="光谱范围" prop="spectralRange">
      </el-table-column>
      <el-table-column align="center" label="波长（nm）">
        <template slot-scope="scope">
          <p v-for="(item,i) in scope.row.wavelength" :key='i'>{{item}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="照射时间（s）">
        <template slot-scope="scope">
          <p v-for="(item,i) in scope.row.irradiationTime" :key='i'>{{item}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="照射量（J/cm2）">
        <template slot='header'>
          <span>照射量（J/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
        <template slot-scope="scope">
          <p v-for="(item,i) in scope.row.irradiationDose" :key='i' >
            <span>{{item.item[0]&&item.item[0]}}</span>
            <sub>{{item.item[1]&&item.item[1]}}</sub><span>{{item.item[2]&&item.item[2]}}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="辐照度（W/cm2）">
        <template slot='header'>
          <span>辐照度（W/cm</span>
          <sup>2</sup>
          <span>)</span>
        </template>
        <template slot-scope='scope'>
          <p v-for="(item,i) in scope.row.irradiance" :key='i' >
            <span>{{item.item[0]&&item.item[0]}}</span>
            <sub>{{item.item[1]&&item.item[1]}}</sub><span>{{item.item[2]&&item.item[2]}}</span>
          </p>
        </template>

      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        eyeLaserData:[]
      }
    },
    created() {
      this.findEyeLaserData()
    },
    props:{
      title:{
        type:String
      },
      category:{
        type:String
      }
    },
    methods:{
      async findEyeLaserData(){
       let category = this.category?this.category:'眼直视激光束'
        let res = await this.$axios.post(this.$serviceAPI.findLaser,{category})
        this.eyeLaserData = res.data.data
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/eyeLaser.vue